import HttpFactory from "@/api/factory"
import type { LoginPayload, LoginResponse } from "@/api/types/auth"

export default class AuthModule extends HttpFactory<any> {
  login(payload: LoginPayload): Promise<FactoryResponse<LoginResponse>> {
    return this.request("POST", "/auth/login", payload)
  }
}
